import classNames from 'classnames';
import { Button } from 'components';
import { FC } from 'react';
import { useTanstackMutation } from 'hooks';
import { queryClient } from 'react-query';
import { LeadApiResponse } from 'models/Lead';
import { API_PATHS } from 'api';
import toast from 'react-hot-toast';

import './DenyLeadbutton.styles.scss';

type DenyLeadButtonProps = {
  leadId: string;
  onSuccess?: () => void;
  className?: string;
};

const DenyLeadButton: FC<DenyLeadButtonProps> = (props) => {
  const { leadId, onSuccess, className } = props;

  const { mutate: selectLeadMutation, isPending: isPendingDeclineLead } =
    useTanstackMutation<LeadApiResponse>({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['lead', { id: leadId }] });
        queryClient.invalidateQueries({ queryKey: ['leads'] });
        queryClient.invalidateQueries({ queryKey: ['tabs'] });
        onSuccess?.();
        toast.success(`Successfully declined lead`);
      },
      onError: (error) => {
        console.error(error);
        toast.error(`Error on declining lead.`);
      },
    });

  const selectLead = () =>
    selectLeadMutation({
      path: API_PATHS.leads.declineLead(leadId),
      method: 'post',
    });

  return (
    <Button
      type="button"
      onClick={selectLead}
      isLoading={isPendingDeclineLead}
      className={classNames('submit-button', 'decline-lead-btn', className)}
    >
      Decline
    </Button>
  );
};

export default DenyLeadButton;
